const QUOTES = [
  {
    quote:
      "Before NZ Taxation I only thought about tax in March. Now after every month I get a clear update and I already know what I owe. Game changer.",
    name: "Ariana M.",
    role: "Sole trader · Content design",
  },
  {
    quote:
      "They cleaned up our Xero file in a week and set up monthly reporting we actually read. Best accounting decision we've made.",
    name: "Joel K.",
    role: "Director · 6-person agency",
  },
  {
    quote:
      "I was nervous about starting my own thing. They handled IRD, GST, and my Xero from day one. Feels like having a CFO on call.",
    name: "Sara T.",
    role: "Start-up founder",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
          What clients say
        </div>
        <h2 className="mt-3 font-heading font-black text-4xl md:text-5xl tracking-tight leading-tight max-w-3xl">
          Real small businesses,<br />real monthly clarity.
        </h2>
        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {QUOTES.map((q, i) => (
            <figure
              key={i}
              className="bg-white border border-slate-200 p-8 flex flex-col gap-6 hover:-translate-y-1 transition-transform"
              data-testid={`testimonial-${i}`}
            >
              <div className="text-[#C9A349] font-heading font-black text-5xl leading-none">“</div>
              <blockquote className="text-slate-800 leading-relaxed flex-1">
                {q.quote}
              </blockquote>
              <figcaption className="border-t border-slate-200 pt-4">
                <div className="font-heading font-bold text-slate-900">{q.name}</div>
                <div className="text-sm text-slate-500">{q.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
